import styled, { css } from 'styled-components';
import { BaseDiv } from '../../common/BaseElements';

export const MEDIA_SIZES = {
  SQUARE: 'square',
  RECT: 'rectangle',
  WIDE: 'wide',
  UWIDE: 'uwide',
  XWIDE: 'xwide',
  PANO: 'panorama'
} as const;

type MediaSizes = typeof MEDIA_SIZES;
export type MediaSize = MediaSizes[keyof MediaSizes];

export const DEFAULT_MEDIA_SIZE = MEDIA_SIZES.RECT;

export const mediaAspectRatio: Record<MediaSize, number> = {
  [MEDIA_SIZES.SQUARE]: 1,
  [MEDIA_SIZES.RECT]: 4 / 3,
  [MEDIA_SIZES.WIDE]: 16 / 9,
  [MEDIA_SIZES.XWIDE]: 14 / 3,
  [MEDIA_SIZES.UWIDE]: 5 / 2,
  [MEDIA_SIZES.PANO]: 4
};

export interface IMediaSizeProps {
  mediaSize?: MediaSize;
}

export const useMediaSizeCss = css<IMediaSizeProps>`
  aspect-ratio: ${({ mediaSize = DEFAULT_MEDIA_SIZE }) => mediaAspectRatio[mediaSize]};
`;

export const MediaSizeContainer = styled(BaseDiv)<IMediaSizeProps>`
  ${useMediaSizeCss}
`;
